import { useState } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dahg0qjoh653ivfvnttg";

type Status = "idle" | "submitting" | "success" | "error";

export default function SubscribeForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const payload = new FormData(form);

    const trap = String(payload.get("contact_alt") || "").trim();
    if (trap) {
      setStatus("success");
      form.reset();
      return;
    }
    payload.delete("contact_alt");

    setStatus("submitting");
    setFormError("");

    const body = new URLSearchParams();
    payload.forEach((value, key) => {
      if (typeof value === "string") body.append(key, value);
    });

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });

      const responseText = await response.text();
      let parsed: {
        code?: string;
        message?: string;
        meta?: { message?: string; detail?: string };
      } | null = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam = /spam/i.test(serverMsg);

      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setFormError(
          isSpam
            ? "提交被拦截，请稍后重试。"
            : serverMsg || "提交失败，请稍后重试。",
        );
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，提交失败，请稍后重试。");
    }
  };

  return (
    <form
      id="gu-subscribe-form"
      data-readdy-form
      onSubmit={handleSubmit}
      className="w-full"
      noValidate
    >
      <div className="flex flex-col gap-3 sm:flex-row">
        <input
          type="text"
          name="nickname"
          placeholder="怎么称呼你（选填）"
          maxLength={30}
          className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200 sm:w-40"
        />
        <input
          type="email"
          name="email"
          required
          placeholder="填写邮箱，收取每日吃瓜速报"
          className="min-w-0 flex-1 rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
        />
        <button
          type="submit"
          disabled={status === "submitting"}
          className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {status === "submitting" ? "提交中…" : "免费订阅"}
        </button>
      </div>

      <input
        type="text"
        name="contact_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="field-optional"
      />

      <div className="mt-3 min-h-[20px] text-xs">
        {status === "success" && (
          <span className="text-secondary-700">
            <i className="ri-checkbox-circle-line mr-1" />
            订阅成功，明天早上第一条速报就会送到你的邮箱。
          </span>
        )}
        {status === "error" && <span className="text-primary-600">{formError}</span>}
        {status === "idle" && (
          <span className="text-foreground-500">
            每周 1-2 封，只发热评和风向，随时可退订。
          </span>
        )}
      </div>
    </form>
  );
}